import api from '../api';
import isGranted from '../auth/isGranted';
import { PaymentMethod } from '../types';

export default {
  findAll(customerId: string): Promise<PaymentMethod[]> {
    if (!isGranted('FIND_PAYMENT_METHODS')) return Promise.reject();
    return api
      .get(`customers/${customerId}/payment-methods`)
      .then(response => response.data);
  },
};
